import { useAuthStore } from "@features/authentication/stores/authStore";
import { OnboardingUserSchema } from "@fitties/shared";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import type { z } from "zod";

const ChatPageOtherUserSchema = OnboardingUserSchema.pick({
  uid: true,
  display_name: true,
  photo_url: true,
});
export type ChatPageOtherUser = z.infer<typeof ChatPageOtherUserSchema>;

export function useChatPage() {
  const { userId } = useAuthStore();
  const { chatId } = useParams<{ chatId: string }>();
  const location = useLocation();
  const navigate = useNavigate();

  const otherUser = location.state?.otherUser as ChatPageOtherUser | undefined;

  return {
    currentUserId: userId,
    chatId,
    otherUser,
    chatNotFound: Boolean(userId && !chatId),
    navigate,
  };
}
